import React, { Component } from 'react';
import { Grid, Row, Col, Icon } from 'rsuite';
import { Link } from 'react-router';

class Symps extends Component {

    componentDidMount = () => {
        // console.log(this.props)
    }


  render() {
    return (
      <div className="r_container">
        <div className="home">


          <div className="new_banner">
            <div className="banner_content">
              <h1>LLM 2025</h1>
              
              <h6>The 2025 International Conference on Large Language Models (LLM)</h6>
              <h6>December 3-5, 2025, Las Vegas, USA</h6>
            </div>

            <div className="new_banner_overlay"></div>
          </div>
          

          <div className="page_content">
            <h6 className="par_header">LLM'25 Research Tracks</h6>
            <div className="par">
            The LLM conference is composed of the following Research Tracks; all
            accepted papers will be included in the proceedings of The 2025
            International Conference on Computational Science and Computational
            Intelligence (LLM), to be published by CPS.
              <div className="sym_links">
                <Icon icon='link' size="1x"/> <Link to="/LLM2025/RTCS">Research Track on Computational Science (LLM-RTCS)</Link><br/>
                <Icon icon='link' size="1x"/> <Link to="/LLM2025/RTCI">Research Track on Computational Intelligence (LLM-RTCI)</Link><br/>
                <Icon icon='link' size="1x"/> <Link to="/LLM2025/RTCW">Research Track on Cyber Warfare, Cyber Defense, & Cyber Security (LLM-RTCW)</Link><br/>
                <Icon icon='link' size="1x"/> <Link to="/LLM2025/RTPC">Research Track on Signal & Image Processing, Computer Vision & Pattern Recognition (LLM-RTPC)</Link><br/>
                <Icon icon='link' size="1x"/> <Link to="/LLM2025/RTSC">Research Track on Smart Cities and Smart Mobility (LLM-RTSC)</Link><br/>
                <Icon icon='link' size="1x"/> <Link to="/LLM2025/RTED">Research Track on Education (LLM-RTED) - includes accreditation, such as ABET</Link><br/>
                <Icon icon='link' size="1x"/> <Link to="/LLM2025/RTHI">Research Track on Health Informatics and Medical Systems (LLM-RTHI)</Link><br/>
                <Icon icon='link' size="1x"/> <Link to="/LLM2025/RTMC">Research Track on Mobile Computing, Wireless Networks, & Security (LLM-RTMC)</Link><br/>
                <Icon icon='link' size="1x"/> <Link to="/LLM2025/RTSE">Research Track on Software Engineering (LLM-RTSE)</Link><br/>
                <Icon icon='link' size="1x"/> <Link to="/LLM2025/RTOT">Research Track on Internet of Things & Internet of Everything (LLM-RTOT)</Link><br/>
                <Icon icon='link' size="1x"/> <Link to="/LLM2025/RTBD">Research Track on Big Data and Data Science (LLM-RTBD)</Link><br/>
                <Icon icon='link' size="1x"/> <Link to="/LLM2025/RTAI">Research Track on Artificial Intelligence (LLM-RTAI)</Link><br/>
                <Icon icon='link' size="1x"/> <Link to="/LLM2025/RTNA">Research Track on Social Network Analysis, Social Media, & Mining (LLM-RTNA)</Link><br/>
                <Icon icon='link' size="1x"/> <Link to="/LLM2025/RTCC">Research Track on Cloud Computing and Data Centers (LLM-RTCC)</Link><br/>
                <Icon icon='link' size="1x"/> <Link to="/LLM2025/RTCB">Research Track on Computational Biology (LLM-RTCB)</Link><br/>
                <Icon icon='link' size="1x"/> <Link to="/LLM2025/RTPD">Research Track on Parallel & Distributed Computing (LLM-RTPD)</Link><br/>
              </div>
              
            </div>
          
          </div>
          

        </div>
      </div>
    );
  }
}

export default Symps;